import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Document, pdfjs, Page } from 'react-pdf';
// eslint-disable-next-line import/extensions
import pdfWorkerSrc from 'pdfjs-dist/build/pdf.worker.min.js';
import ProposalFeedbacks from '../../ProposalFeedbacks';
import loading from '../../../../assets/images/spinner-DNA-2s-200px.svg';
import './Resume.scss';
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerSrc;
var cloraSpinner = function cloraSpinner() {
  return /*#__PURE__*/React.createElement("div", {
    className: "loading"
  }, /*#__PURE__*/React.createElement("img", {
    src: loading,
    alt: "Loading_image"
  }));
};
function Resume(_ref) {
  var document = _ref.document,
    originalDocument = _ref.originalDocument,
    returnPath = _ref.returnPath,
    returnText = _ref.returnText,
    showHeader = _ref.showHeader,
    isSignedIn = _ref.isSignedIn,
    admin = _ref.admin,
    canEditFeedback = _ref.canEditFeedback,
    ownerName = _ref.ownerName,
    candidateName = _ref.candidateName,
    proposalResourceId = _ref.proposalResourceId,
    id = _ref.id,
    consultantFit = _ref.consultantFit,
    note = _ref.note,
    csrfToken = _ref.csrfToken,
    email = _ref.email,
    feedbacks = _ref.feedbacks,
    isPdf = _ref.isPdf,
    downloadUrl = _ref.downloadUrl;
  var width = Math.min(window.innerWidth, 768);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    numPages = _useState2[0],
    setNumPages = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    pdfError = _useState4[0],
    setPdfError = _useState4[1];
  function onDocumentLoadSuccess(proxy) {
    setNumPages(proxy._pdfInfo.numPages);
  }
  var pages = [];
  for (var i = 1; i <= numPages; i += 1) {
    pages.push(i);
  }
  var resolvedDownloadUrl = downloadUrl || document || originalDocument;
  if (!isPdf || pdfError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "style-guide resume-non-pdf"
    }, showHeader && /*#__PURE__*/React.createElement("div", {
      className: "header-buttons row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "return-link col-sm-5"
    }, returnPath ? /*#__PURE__*/React.createElement("div", {
      className: "back-to-project style-guide"
    }, /*#__PURE__*/React.createElement("a", {
      className: "body-text-2 medium-weight",
      href: returnPath
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-chevron-left"
    }), returnText)) : ''), /*#__PURE__*/React.createElement("div", {
      className: "download-section col-sm-5"
    }, resolvedDownloadUrl && /*#__PURE__*/React.createElement("a", {
      className: "btn btn-secondary",
      href: resolvedDownloadUrl
    }, "Download File")))), /*#__PURE__*/React.createElement("div", {
      className: "row resume-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-sm-12 body-text-2"
    }, "This file can\u2019t be previewed inline. Please download it to view.")));
  }
  return /*#__PURE__*/React.createElement(Document, {
    file: document,
    loading: cloraSpinner(),
    onLoadSuccess: onDocumentLoadSuccess,
    onLoadError: setPdfError
  }, showHeader && /*#__PURE__*/React.createElement("div", {
    className: "header-buttons row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "return-link col-sm-4"
  }, returnPath ? /*#__PURE__*/React.createElement("div", {
    className: "back-to-project style-guide"
  }, /*#__PURE__*/React.createElement("a", {
    className: "body-text-2 medium-weight",
    href: returnPath
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-chevron-left"
  }), returnText)) : ''), /*#__PURE__*/React.createElement("div", {
    className: "download-section col-sm-4"
  }, admin && originalDocument && /*#__PURE__*/React.createElement("a", {
    className: "btn btn-secondary",
    href: originalDocument
  }, "Download File")))), isSignedIn && !admin && consultantFit === null && proposalResourceId && canEditFeedback && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "feedback-section col-sm-12"
  }, /*#__PURE__*/React.createElement(ProposalFeedbacks, {
    isSignedIn: isSignedIn,
    admin: admin,
    canEditFeedback: canEditFeedback,
    ownerName: ownerName,
    candidateName: candidateName,
    proposalResourceId: proposalResourceId,
    id: id,
    consultantFit: consultantFit,
    note: note,
    csrfToken: csrfToken,
    email: email,
    feedbacks: feedbacks,
    location: "resume"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row resume-container"
  }, pages.map(function (pageNum) {
    return /*#__PURE__*/React.createElement(Page, {
      renderAnnotationLayer: false,
      renderTextLayer: false,
      pageNumber: pageNum,
      width: width
    });
  })));
}
Resume.propTypes = {
  document: PropTypes.string,
  originalDocument: PropTypes.string,
  downloadUrl: PropTypes.string,
  isPdf: PropTypes.bool,
  returnPath: PropTypes.string,
  returnText: PropTypes.string,
  feedbacks: PropTypes.arrayOf(PropTypes.shape({})),
  isSignedIn: PropTypes.bool,
  admin: PropTypes.bool,
  canEditFeedback: PropTypes.bool,
  ownerName: PropTypes.string,
  candidateName: PropTypes.string,
  proposalResourceId: PropTypes.string,
  id: PropTypes.string,
  consultantFit: PropTypes.string,
  note: PropTypes.string,
  csrfToken: PropTypes.string,
  email: PropTypes.string,
  showHeader: PropTypes.bool
};
Resume.defaultProps = {
  returnPath: null,
  returnText: 'Back to Proposal',
  feedbacks: [],
  isSignedIn: false,
  admin: false,
  canEditFeedback: false,
  ownerName: '',
  candidateName: '',
  proposalResourceId: '',
  id: '',
  consultantFit: '',
  note: '',
  csrfToken: '',
  email: '',
  showHeader: true,
  originalDocument: '',
  document: '',
  downloadUrl: '',
  isPdf: true
};
export default Resume;